/**
 * FUMÉ REWARDS — Main JS
 * Upload to: Online Store > Themes > Edit Code > Assets > fume-rewards.js
 * v2 — Mensaje de cooldown en minutos cuando el límite es menor a 1 hora
 */

const SUPABASE_URL = 'https://yynpokopatxqnifyxwqu.supabase.co';
const SUPABASE_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inl5bnBva29wYXR4cW5pZnl4d3F1Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODEwMzI5NzgsImV4cCI6MjA5NjYwODk3OH0.gCVdIs6GZMtragKF6JTy5y8IfzPYtjcQoZjOfeW9lyQ';

// ─── DEFAULTS (used if Supabase settings fail to load) ──────────────────────
let SETTINGS = {
  colors:   { gold: '#C9A84C', bg: '#0a0a0a', bg2: '#111111' },
  tiers:    [{ name:'BRONCE',min:0,mult:1 },{ name:'PLATA',min:500,mult:1.25 },{ name:'ORO',min:1000,mult:1.5 },{ name:'PLATINO',min:2500,mult:2 }],
  points:   { buy: 50, recycle: 20, cooldownHours: 24 },
  rewards:  [
    { id:'rw1',  name:'Playera FUMÉ',          desc:'Playera negra premium con logo FUMÉ bordado.',                 pts:500,  type:'Merch',     emoji:'👕' },
    { id:'rw2',  name:'Gorra FUMÉ',            desc:'Gorra snapback negra con bordado dorado FUMÉ.',                pts:400,  type:'Merch',     emoji:'🧢' },
    { id:'rw3',  name:'Encendedor FUMÉ',       desc:'Encendedor de marca personalizado. Edición limitada.',         pts:250,  type:'Merch',     emoji:'🔥' },
    { id:'rw4',  name:'10% de Descuento',      desc:'Obtén 10% de descuento en tu próxima compra en fumehn.com.',   pts:200,  type:'Discount',  emoji:'💸' },
    { id:'rw5',  name:'20% de Descuento',      desc:'Obtén 20% de descuento en tu próxima compra en fumehn.com.',   pts:400,  type:'Discount',  emoji:'💸' },
    { id:'rw6',  name:'Envío Gratis',          desc:'Envío gratis en tu próxima compra en línea.',                  pts:150,  type:'Discount',  emoji:'📦' },
    { id:'rw7',  name:'Tarjeta de Regalo L100',desc:'Tarjeta de regalo digital, canjeable en fumehn.com.',          pts:600,  type:'Gift Card', emoji:'💳' },
    { id:'rw8',  name:'Tarjeta de Regalo L250',desc:'Tarjeta de regalo digital, canjeable en fumehn.com.',          pts:1200, type:'Gift Card', emoji:'💳' },
    { id:'rw9',  name:'FUMÉ MINI Gratis',      desc:'Canjea por un FUMÉ MINI gratis del sabor que elijas.',         pts:300,  type:'Product',   emoji:'🎁' },
    { id:'rw10', name:'FUMÉ+ TWIST Gratis',    desc:'Canjea por un FUMÉ+ TWIST gratis del sabor que elijas.',       pts:500,  type:'Product',   emoji:'🎁' },
  ],
  buyCodes: [
    { code:'FUME-BUY-MINI',    name:'FUMÉ MINI',        pts:50 },
    { code:'FUME-BUY-TWIST',   name:'FUMÉ+ TWIST',      pts:50 },
    { code:'FUME-BUY-COLORS',  name:'FUMÉ COLORS',      pts:50 },
    { code:'FUME-BUY-MAX',     name:'FUMÉ MAX',          pts:50 },
    { code:'FUME-BUY-POUCHES', name:'FUMÉ NIC POUCHES',  pts:50 },
  ],
  numStores: 78,
  recycleNames: {}, // { 'FUME-RECYCLE-001': 'Tegucigalpa - Multiplaza', ... } — set from FUMÉ Admin
};

// ─── SUPABASE CLIENT ────────────────────────────────────────────────────────
const db = {
  async request(method, path, body = null) {
    const opts = {
      method,
      headers: {
        'apikey': SUPABASE_KEY,
        'Authorization': `Bearer ${SUPABASE_KEY}`,
        'Content-Type': 'application/json',
        'Prefer': 'return=representation',
      },
    };
    if (body) opts.body = JSON.stringify(body);
    const res = await fetch(`${SUPABASE_URL}/rest/v1/${path}`, opts);
    if (!res.ok) throw new Error(await res.text());
    const text = await res.text();
    return text ? JSON.parse(text) : null;
  },

  async loadSettings() {
    try {
      const rows = await this.request('GET', 'settings?select=key,value');
      if (!rows || !rows.length) return;
      rows.forEach(r => {
        if (r.key === 'colors')    SETTINGS.colors    = r.value;
        if (r.key === 'tiers')     SETTINGS.tiers     = r.value;
        if (r.key === 'points')    SETTINGS.points    = r.value;
        if (r.key === 'rewards')   SETTINGS.rewards   = r.value;
        if (r.key === 'buyCodes')  SETTINGS.buyCodes  = r.value;
        if (r.key === 'numStores') SETTINGS.numStores = r.value;
        if (r.key === 'recycleNames') SETTINGS.recycleNames = r.value;
      });
      applyColors();
    } catch(e) { console.warn('Settings load failed, using defaults', e); }
  },

  async getCustomer(identifier) {
    try {
      const rows = await this.request('GET', `customers?shopify_customer_id=eq.${encodeURIComponent(identifier)}&select=*`);
      if (rows?.[0]) return rows[0];
    } catch(e) {}
    try {
      const rows = await this.request('GET', `customers?email=eq.${encodeURIComponent(identifier)}&select=*`);
      if (rows?.[0]) return rows[0];
    } catch(e) {}
    return null;
  },

  async createCustomer(identifier, email) {
    const rows = await this.request('POST', 'customers', {
      shopify_customer_id: identifier,
      email: email || identifier,
      pts: 0, scans: 0, redeemed: 0, activity: [], scan_log: {},
    });
    return rows?.[0] || null;
  },

  async updateCustomer(identifier, updates) {
    const rows = await this.request(
      'PATCH',
      `customers?shopify_customer_id=eq.${encodeURIComponent(identifier)}&select=*`,
      updates
    );
    return rows?.[0] || null;
  },

  // ── REDEMPTIONS ──
  async createRedemption(row) {
    const rows = await this.request('POST', 'redemptions', row);
    return rows?.[0] || null;
  },

  async getRedemptions(identifier) {
    try {
      return await this.request(
        'GET',
        `redemptions?customer_identifier=eq.${encodeURIComponent(identifier)}&order=created_at.desc`
      );
    } catch(e) { return []; }
  },
};

// ─── APPLY COLORS ────────────────────────────────────────────────────────────
function applyColors() {
  const c = SETTINGS.colors;
  if (!c) return;
  const r = document.documentElement.style;
  if (c.gold) r.setProperty('--fr-gold', c.gold);
  if (c.bg)   r.setProperty('--fr-bg',   c.bg);
  if (c.bg2)  r.setProperty('--fr-bg2',  c.bg2);
}

const SHOPIFY_STORE    = 'fumehn.myshopify.com';
let   ALL_CODES_CACHE  = null;

async function loadQRCodes() {
  if (ALL_CODES_CACHE) return ALL_CODES_CACHE;
  try {
    let allEntries = [], cursor = null, hasMore = true;
    while (hasMore) {
      const afterClause = cursor ? `, after: "${cursor}"` : '';
      const query = `{
        metaobjects(type: "fume_qr_code", first: 50${afterClause}) {
          edges {
            cursor
            node { fields { key value } }
          }
          pageInfo { hasNextPage }
        }
      }`;
      const res  = await fetch(`https://${SHOPIFY_STORE}/api/2024-01/graphql.json`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ query }),
      });
      const data = await res.json();
      const edges = data?.data?.metaobjects?.edges || [];
      allEntries = allEntries.concat(edges);
      hasMore = data?.data?.metaobjects?.pageInfo?.hasNextPage;
      cursor  = edges.length ? edges[edges.length - 1].cursor : null;
    }
    const map = {};
    allEntries.forEach(({ node }) => {
      const f = {};
      node.fields.forEach(({ key, value }) => f[key] = value);
      if (f.active === 'true' && f.code) {
        map[f.code.toUpperCase()] = {
          name: f.name || f.code,
          pts:  parseInt(f.pts) || 20,
          type: f.type || 'buy',
        };
      }
    });
    ALL_CODES_CACHE = map;
    return map;
  } catch(e) {
    console.warn('Could not load QR codes from Shopify, using defaults', e);
    return buildFallbackCodes();
  }
}

function buildFallbackCodes() {
  const all = {};
  (SETTINGS.buyCodes || []).forEach(c => {
    all[c.code] = { name: c.name, pts: c.pts, type: 'buy' };
  });
  const n = parseInt(SETTINGS.numStores) || 78;
  const customNames = SETTINGS.recycleNames || {};
  for (let i = 1; i <= n; i++) {
    const id = String(i).padStart(3, '0');
    const code = `FUME-RECYCLE-${id}`;
    const name = customNames[code] || `Sucursal #${id} Reciclaje`;
    all[code] = { name, pts: SETTINGS.points.recycle || 20, type: 'recycle' };
  }
  return all;
}

function buildAllCodes() { return ALL_CODES_CACHE || buildFallbackCodes(); }

// ─── APP ────────────────────────────────────────────────────────────────────
const fumeRewards = (() => {
  const app = document.getElementById('fume-rewards-app');
  if (!app) return {};

  const shopifyId = app.dataset.customerId;
  const email     = app.dataset.customerEmail;
  const identifier = (email && email !== '' && email !== 'nil') ? email : shopifyId;
  const loggedIn   = identifier && identifier !== '' && identifier !== 'nil' && identifier !== 'null';

  if (!loggedIn) return {};

  let customer       = null;
  let qrScanner      = null;
  let activeFilter   = 'All';
  let pendingReward  = null;
  let myRedemptions  = [];
  let addrReward     = null;
  const TYPE_LABELS  = { All:'TODOS', Merch:'MERCH', Discount:'DESCUENTOS', 'Gift Card':'TARJETAS DE REGALO', Product:'PRODUCTOS' };

  // ── INIT ──
  async function init() {
    setupTabs();
    showLoading(true);
    await db.loadSettings();
    await loadQRCodes(); // load from Shopify
    try {
      customer = await db.getCustomer(identifier);
      if (!customer) customer = await db.createCustomer(identifier, email);
    } catch(e) { console.error('Init error:', e); }
    try { myRedemptions = await db.getRedemptions(identifier) || []; } catch(e) {}
    showLoading(false);
    refreshDash();
    updateNavPts();
  }

  function showLoading(on) {
    const el = document.getElementById('fr-loading');
    if (el) el.classList.toggle('hidden', !on);
  }

  // ── TABS ──
  function setupTabs() {
    document.querySelectorAll('.fr-tab').forEach(btn => {
      btn.addEventListener('click', () => {
        const tab = btn.dataset.tab;
        document.querySelectorAll('.fr-tab').forEach(b => b.classList.remove('active'));
        document.querySelectorAll('.fr-page').forEach(p => p.classList.remove('active'));
        btn.classList.add('active');
        document.getElementById(`tab-${tab}`).classList.add('active');
        if (tab === 'scanner') initScanner();
        else stopScanner();
        if (tab === 'store') renderStore();
        if (tab === 'dashboard') refreshDash();
      });
    });
  }

  // ── DASHBOARD ──
  function getTier(pts) {
    const tiers = SETTINGS.tiers || [];
    for (let i = tiers.length - 1; i >= 0; i--) {
      if (pts >= tiers[i].min) return tiers[i];
    }
    return tiers[0] || { name: 'BRONCE', min: 0 };
  }

  function refreshDash() {
    if (!customer) return;
    const pts = customer.pts || 0;
    document.getElementById('fr-total-pts').textContent      = pts.toLocaleString();
    document.getElementById('fr-total-scans').textContent    = customer.scans || 0;
    document.getElementById('fr-total-redeemed').textContent = customer.redeemed || 0;

    const tier   = getTier(pts);
    const tiers  = SETTINGS.tiers || [];
    document.getElementById('fr-tier').textContent      = tier.name;
    document.getElementById('fr-tier-name').textContent = tier.name;

    const nextTier = tiers.find(t => t.min > pts);
    let pct = 100, nextLabel = 'NIVEL MÁXIMO ALCANZADO';
    if (nextTier) {
      const range = nextTier.min - tier.min;
      const prog  = pts - tier.min;
      pct = Math.min(100, Math.round((prog / range) * 100));
      nextLabel = `${(nextTier.min - pts).toLocaleString()} pts para ${nextTier.name}`;
    }
    document.getElementById('fr-tier-fill').style.width  = pct + '%';
    document.getElementById('fr-tier-next').textContent  = nextLabel;

    // Update tier badges dynamically
    const badgesEl = document.getElementById('fr-tier-badges');
    if (badgesEl) {
      badgesEl.innerHTML = tiers.map(t => `
        <span class="fr-tb${t.name === tier.name ? ' fr-tb-active' : ''}">${t.name}</span>`).join('');
    }

    const activity = customer.activity || [];
    const list = document.getElementById('fr-activity-list');
    if (!activity.length) {
      list.innerHTML = '<div class="fr-empty">Aún no hay actividad. ¡Escanea tu primer código!</div>';
      return;
    }
    list.innerHTML = activity.slice().reverse().slice(0, 10).map(a => `
      <div class="fr-activity-item">
        <div>
          <div class="fr-activity-desc">${a.desc}</div>
          <div class="fr-activity-date">${new Date(a.date).toLocaleDateString()}</div>
        </div>
        <div class="fr-activity-pts">${a.pts > 0 ? '+' : ''}${a.pts} pts</div>
      </div>`).join('');
  }

  function updateNavPts() {
    if (!customer) return;
    document.getElementById('fr-nav-pts').textContent = (customer.pts || 0).toLocaleString() + ' PTS';
  }

  // ── SCANNER ──
  function initScanner() {
    if (qrScanner) return;
    qrScanner = new Html5Qrcode('fr-qr-reader');
    qrScanner.start(
      { facingMode: 'environment' },
      { fps: 10, qrbox: 250 },
      code => submitCode(code.trim()),
      () => {}
    ).catch(() => {
      document.getElementById('fr-qr-reader').innerHTML =
        '<p class="fr-scanner-fallback">Cámara no disponible. Ingresa tu código manualmente abajo.</p>';
      qrScanner = null;
    });
  }

  function stopScanner() {
    if (qrScanner) { qrScanner.stop().catch(() => {}); qrScanner = null; }
  }

  async function submitCode(raw) {
    const code    = raw.toUpperCase().trim();
    const allCodes = buildAllCodes();
    hideErr('fr-scan-err');
    hideScanSuccess();

    const product = allCodes[code];
    if (!product) { showErr('fr-scan-err', 'Código no reconocido. Escanea un código QR válido de FUMÉ.'); return; }

    if (product.type === 'buy') {
      showErr('fr-scan-err', 'Los puntos por compra estarán disponibles pronto. ¡Por ahora recicla y gana!');
      return;
    }

    const cooldown = ((SETTINGS.points || {}).cooldownHours || 24) * 3600000;
    const now      = Date.now();
    const scanLog  = customer.scan_log || {};
    const last     = scanLog[code] || 0;
    if (now - last < cooldown) {
      const ch = (SETTINGS.points || {}).cooldownHours || 24;
      const cdLabel = ch < 1
        ? `los últimos ${Math.max(1, Math.round(ch * 60))} minutos`
        : `las últimas ${ch} horas`;
      showErr('fr-scan-err', `Este código ya fue escaneado en ${cdLabel}.`);
      return;
    }

    try {
      const tier      = getTier(customer.pts || 0);
      const mult      = tier.mult || 1;
      const earned    = Math.round(product.pts * mult);
      const newPts    = (customer.pts || 0) + earned;
      const newScans  = (customer.scans || 0) + 1;
      const newScanLog = { ...scanLog, [code]: now };
      const newActivity = [
        ...(customer.activity || []),
        {
          desc: product.type === 'recycle'
            ? `Reciclaste un dispositivo en ${product.name}${mult > 1 ? ` (×${mult} ${tier.name})` : ''}`
            : `Compraste ${product.name}${mult > 1 ? ` (×${mult} ${tier.name})` : ''}`,
          pts:  earned,
          date: new Date().toISOString(),
        }
      ].slice(-50);

      customer = await db.updateCustomer(identifier, {
        pts: newPts, scans: newScans, scan_log: newScanLog, activity: newActivity,
      });

      updateNavPts();
      refreshDash();
      showScanSuccess(product, earned, mult, tier);
      document.getElementById('fr-manual-input').value = '';

      // Pause scanner so customer can read the result
      if (qrScanner) {
        qrScanner.pause(true);
        setTimeout(() => { if (qrScanner) qrScanner.resume(); }, 8000);
      }
    } catch(e) {
      showErr('fr-scan-err', 'Error al guardar los puntos. Inténtalo de nuevo.');
      console.error(e);
    }
  }

  function showScanSuccess(product, earned, mult, tier) {
    ensureScanPopup();
    document.getElementById('fr-popup-pts').textContent     = '+' + earned;
    document.getElementById('fr-popup-label').textContent   = product.type === 'recycle' ? 'PUNTOS POR RECICLAJE' : 'PUNTOS POR COMPRA';
    document.getElementById('fr-popup-product').textContent = product.name;
    document.getElementById('fr-popup-total').textContent   = 'Total: ' + (customer.pts || 0).toLocaleString() + ' pts';
    const multEl = document.getElementById('fr-popup-mult');
    if (multEl) multEl.textContent = mult > 1 ? `×${mult} multiplicador ${tier.name}` : '';

    const overlay = document.getElementById('fr-popup-overlay');
    const bar     = document.getElementById('fr-popup-bar-fill');
    overlay.classList.add('show');
    bar.style.transition = 'none';
    bar.style.width = '0%';
    requestAnimationFrame(() => {
      requestAnimationFrame(() => {
        bar.style.transition = 'width 10s linear';
        bar.style.width = '100%';
      });
    });

    if (window._popupTimer) clearTimeout(window._popupTimer);
    window._popupTimer = setTimeout(() => hideScanSuccess(), 10000);
  }

  function hideScanSuccess() {
    const overlay = document.getElementById('fr-popup-overlay');
    if (overlay) overlay.classList.remove('show');
  }

  function ensureScanPopup() {
    if (document.getElementById('fr-popup-overlay')) return;
    const gold = (SETTINGS.colors && SETTINGS.colors.gold) || '#C9A84C';
    const style = document.createElement('style');
    style.textContent = `
      #fr-popup-overlay{position:fixed;inset:0;background:rgba(0,0,0,.65);
        z-index:99997;display:flex;align-items:flex-end;justify-content:center;
        opacity:0;pointer-events:none;transition:opacity .25s ease}
      #fr-popup-overlay.show{opacity:1;pointer-events:auto}
      #fr-popup-sheet{background:#111;border-radius:22px 22px 0 0;
        border-top:1px solid rgba(255,255,255,.08);width:100%;max-width:480px;
        padding:14px 20px 28px;text-align:center;
        transform:translateY(100%);transition:transform .35s cubic-bezier(.32,1.2,.5,1)}
      #fr-popup-overlay.show #fr-popup-sheet{transform:translateY(0)}
      #fr-popup-handle{width:36px;height:4px;background:#333;border-radius:2px;margin:0 auto 16px}
      #fr-popup-check{width:44px;height:44px;border-radius:50%;
        border:2px solid ${gold};display:flex;align-items:center;justify-content:center;
        margin:0 auto 10px;font-size:20px;color:${gold};font-weight:700}
      #fr-popup-pts{font-size:3rem;font-weight:800;color:${gold};letter-spacing:-1px;line-height:1}
      #fr-popup-label{font-size:.65rem;letter-spacing:3px;color:#888;margin-top:4px}
      #fr-popup-product{font-size:.9rem;color:#ddd;margin-top:8px;font-weight:600}
      #fr-popup-total{font-size:.75rem;color:#666;margin-top:4px}
      #fr-popup-bar-wrap{height:3px;background:#222;border-radius:2px;margin-top:18px;overflow:hidden}
      #fr-popup-bar-fill{height:100%;width:0%;background:${gold};border-radius:2px}
      #fr-popup-tap{font-size:.65rem;letter-spacing:1px;color:#555;margin-top:10px}
    `;
    document.head.appendChild(style);

    const overlay = document.createElement('div');
    overlay.id = 'fr-popup-overlay';
    overlay.innerHTML = `
      <div id="fr-popup-sheet">
        <div id="fr-popup-handle"></div>
        <div id="fr-popup-check">✓</div>
        <div id="fr-popup-pts">+50</div>
        <div id="fr-popup-label">PUNTOS POR COMPRA</div>
        <div id="fr-popup-mult" style="font-size:.65rem;letter-spacing:2px;color:#C9A84C;margin-top:4px;font-weight:700"></div>
        <div id="fr-popup-product"></div>
        <div id="fr-popup-total"></div>
        <div id="fr-popup-bar-wrap"><div id="fr-popup-bar-fill"></div></div>
        <div id="fr-popup-tap">Toca para cerrar</div>
      </div>`;
    document.body.appendChild(overlay);
    overlay.addEventListener('click', () => {
      hideScanSuccess();
      if (window._popupTimer) clearTimeout(window._popupTimer);
    });
  }

  // ── REWARDS STORE ──
  function renderStore() {
    const pts     = customer?.pts || 0;
    const rewards = SETTINGS.rewards || [];
    document.getElementById('fr-store-pts').textContent = pts.toLocaleString() + ' PTS';
    const types = ['All', ...new Set(rewards.map(r => r.type))];
    document.getElementById('fr-filters').innerHTML = types.map(t =>
      `<button class="fr-filter${t === activeFilter ? ' active' : ''}" onclick="fumeRewards.filterBy('${t}')">${(TYPE_LABELS[t] || t).toUpperCase()}</button>`
    ).join('');

    let list = activeFilter === 'All' ? rewards.slice() : rewards.filter(r => r.type === activeFilter);
    list.sort((a,b) => a.pts - b.pts);
    document.getElementById('fr-rewards-grid').innerHTML = list.map(r => {
      const can = pts >= r.pts;
      const imgContent = r.image
        ? `<img src="${r.image}" alt="${r.name}" style="width:100%;height:100%;object-fit:cover;cursor:zoom-in" onclick="fumeRewards.zoomImage('${r.id}')"/>
           <span class="fr-zoom-hint" onclick="fumeRewards.zoomImage('${r.id}')">⤢</span>`
        : r.emoji;
      return `<div class="fr-reward-card">
        <div class="fr-reward-img" style="${r.image?'padding:0;overflow:hidden;position:relative':''}">${imgContent}</div>
        <div class="fr-reward-body">
          <div class="fr-reward-tag">${TYPE_LABELS[r.type] || r.type}</div>
          <div class="fr-reward-name">${r.name}</div>
          <div class="fr-reward-desc">${r.desc}</div>
          <div class="fr-reward-footer">
            <div class="fr-reward-pts">${r.pts.toLocaleString()} <span>pts</span></div>
            <button class="fr-redeem-btn" ${can ? '' : 'disabled'} onclick="fumeRewards.openModal('${r.id}')">
              ${can ? 'CANJEAR' : 'TE FALTAN PUNTOS'}
            </button>
          </div>
        </div>
      </div>`;
    }).join('');

    // Inject "My Redemptions" button above the grid (once)
    const grid = document.getElementById('fr-rewards-grid');
    if (grid && !document.getElementById('fr-history-btn')) {
      ensureRedeemUI();
      const btn = document.createElement('button');
      btn.id = 'fr-history-btn';
      btn.className = 'fr-history-btn';
      btn.textContent = '📦 Mis Canjes';
      btn.addEventListener('click', openHistory);
      grid.parentNode.insertBefore(btn, grid);
    }
  }

  function filterBy(type) { activeFilter = type; renderStore(); }
  function sortBy(val)    { activeSort = val;   renderStore(); }

  // ── IMAGE LIGHTBOX ──
  function ensureLightbox() {
    if (document.getElementById('fr-lightbox')) return;
    const style = document.createElement('style');
    style.textContent = `
      #fr-lightbox{position:fixed;inset:0;background:rgba(0,0,0,.92);display:flex;
        align-items:center;justify-content:center;z-index:99999;opacity:0;
        pointer-events:none;transition:opacity .2s ease;padding:24px}
      #fr-lightbox.show{opacity:1;pointer-events:auto}
      #fr-lightbox-img{max-width:100%;max-height:90vh;object-fit:contain;
        border-radius:12px;box-shadow:0 20px 60px rgba(0,0,0,.6)}
      #fr-lightbox-close{position:absolute;top:18px;right:24px;font-size:40px;
        line-height:1;color:#fff;cursor:pointer;background:none;border:none}
      .fr-zoom-hint{position:absolute;bottom:8px;right:8px;width:28px;height:28px;
        display:flex;align-items:center;justify-content:center;border-radius:50%;
        background:rgba(0,0,0,.55);color:#fff;font-size:15px;cursor:zoom-in;
        pointer-events:auto}
      .fr-sort-select{background:#111;border:1px solid #333;border-radius:20px;
        padding:.4rem .9rem;color:#aaa;cursor:pointer;font-size:.75rem;
        letter-spacing:1px;outline:none;margin-left:auto}
    `;
    document.head.appendChild(style);
    const box = document.createElement('div');
    box.id = 'fr-lightbox';
    box.innerHTML = `<button id="fr-lightbox-close" aria-label="Cerrar">&times;</button><img id="fr-lightbox-img" alt=""/>`;
    box.addEventListener('click', e => { if (e.target.id !== 'fr-lightbox-img') closeImage(); });
    document.addEventListener('keydown', e => { if (e.key === 'Escape') closeImage(); });
    document.body.appendChild(box);
  }

  function zoomImage(id) {
    const r = (SETTINGS.rewards || []).find(x => x.id === id);
    if (!r || !r.image) return;
    ensureLightbox();
    const box = document.getElementById('fr-lightbox');
    document.getElementById('fr-lightbox-img').src = r.image;
    document.getElementById('fr-lightbox-img').alt = r.name;
    box.classList.add('show');
  }

  function closeImage() {
    const box = document.getElementById('fr-lightbox');
    if (box) box.classList.remove('show');
  }

  // ── REDEEM / SHIPPING / HISTORY UI ──
  function needsShipping(type) {
    // Physical rewards we mail out. Discounts & gift cards are digital.
    return type === 'Merch' || type === 'Product';
  }

  function ensureRedeemUI() {
    if (document.getElementById('fr-addr-overlay')) return;
    const gold = (SETTINGS.colors && SETTINGS.colors.gold) || '#C9A84C';
    const style = document.createElement('style');
    style.textContent = `
      .fr-ov{position:fixed;inset:0;background:rgba(0,0,0,.85);display:flex;
        align-items:center;justify-content:center;z-index:99998;opacity:0;
        pointer-events:none;transition:opacity .2s;padding:18px}
      .fr-ov.show{opacity:1;pointer-events:auto}
      .fr-sheet{background:#111;border:1px solid rgba(255,255,255,.08);border-radius:16px;
        width:100%;max-width:440px;max-height:88vh;overflow:auto;padding:22px;color:#fff;
        box-shadow:0 24px 70px rgba(0,0,0,.6)}
      .fr-sheet h3{margin:0 0 4px;font-size:18px;letter-spacing:.5px}
      .fr-sheet .fr-sub{color:#999;font-size:13px;margin-bottom:16px}
      .fr-sheet .fr-sub.hidden{display:none}
      .fr-field{margin-bottom:12px}
      .fr-field label{display:block;font-size:12px;color:#bbb;margin-bottom:5px;text-transform:uppercase;letter-spacing:.5px}
      .fr-field input,.fr-field textarea{width:100%;box-sizing:border-box;background:#0a0a0a;
        border:1px solid rgba(255,255,255,.12);border-radius:9px;padding:11px 12px;color:#fff;font-size:14px}
      .fr-field textarea{resize:vertical;min-height:60px}
      .fr-sheet-actions{display:flex;gap:10px;margin-top:18px}
      .fr-btn-primary{flex:1;background:${gold};color:#000;border:none;border-radius:9px;
        padding:13px;font-weight:700;font-size:14px;cursor:pointer;letter-spacing:.5px}
      .fr-btn-ghost{flex:1;background:none;color:#bbb;border:1px solid rgba(255,255,255,.15);
        border-radius:9px;padding:13px;font-weight:600;font-size:14px;cursor:pointer}
      .fr-history-btn{display:block;width:100%;margin:0 0 16px;background:none;
        border:1px solid ${gold};color:${gold};border-radius:10px;padding:12px;
        font-weight:700;font-size:13px;letter-spacing:.5px;cursor:pointer}
      .fr-redo{border:1px solid rgba(255,255,255,.08);border-radius:12px;padding:14px;margin-bottom:12px;background:#0d0d0d}
      .fr-redo-top{display:flex;justify-content:space-between;align-items:flex-start;gap:10px}
      .fr-redo-name{font-weight:700;font-size:15px}
      .fr-redo-meta{font-size:12px;color:#888;margin-top:2px}
      .fr-redo-pts{color:${gold};font-weight:700;font-size:13px;white-space:nowrap;margin-top:4px}
      .fr-badge{display:inline-block;font-size:11px;font-weight:700;padding:3px 9px;border-radius:20px;letter-spacing:.5px;text-transform:uppercase}
      .fr-step{display:flex;align-items:flex-start;margin-top:14px}
      .fr-step .s{flex:1;text-align:center;font-size:10px;color:#666;position:relative;text-transform:uppercase;letter-spacing:.3px}
      .fr-step .s .dot{width:12px;height:12px;border-radius:50%;background:#333;margin:0 auto 5px;border:2px solid #333;position:relative;z-index:1}
      .fr-step .s.done .dot{background:${gold};border-color:${gold}}
      .fr-step .s.done{color:#ddd}
      .fr-step .s::before{content:'';position:absolute;top:6px;left:-50%;width:100%;height:2px;background:#333;z-index:0}
      .fr-step .s:first-child::before{display:none}
      .fr-step .s.done::before{background:${gold}}
      .fr-track{font-size:12px;color:#aaa;margin-top:12px;word-break:break-all}
      .fr-redo-empty{color:#888;text-align:center;padding:30px 10px;font-size:14px}
    `;
    document.head.appendChild(style);

    // Shipping address overlay
    const addr = document.createElement('div');
    addr.className = 'fr-ov';
    addr.id = 'fr-addr-overlay';
    addr.innerHTML = `
      <div class="fr-sheet">
        <h3 id="fr-addr-title">DATOS DE ENVÍO</h3>
        <div class="fr-sub">¿A dónde enviamos tu recompensa?</div>
        <div class="fr-field"><label>Nombre completo</label><input id="fr-addr-name" type="text" autocomplete="name"/></div>
        <div class="fr-field"><label>Teléfono</label><input id="fr-addr-phone" type="tel" autocomplete="tel"/></div>
        <div class="fr-field"><label>Dirección</label><textarea id="fr-addr-address" autocomplete="street-address"></textarea></div>
        <div class="fr-field"><label>Ciudad</label><input id="fr-addr-city" type="text" autocomplete="address-level2"/></div>
        <div id="fr-addr-err" class="fr-sub hidden" style="color:#e66"></div>
        <div class="fr-sheet-actions">
          <button class="fr-btn-ghost" id="fr-addr-cancel">Cancelar</button>
          <button class="fr-btn-primary" id="fr-addr-submit">CONFIRMAR</button>
        </div>
      </div>`;
    document.body.appendChild(addr);
    addr.querySelector('#fr-addr-cancel').addEventListener('click', closeAddressForm);
    addr.querySelector('#fr-addr-submit').addEventListener('click', submitAddressForm);
    addr.addEventListener('click', e => { if (e.target === addr) closeAddressForm(); });

    // History overlay
    const hist = document.createElement('div');
    hist.className = 'fr-ov';
    hist.id = 'fr-hist-overlay';
    hist.innerHTML = `
      <div class="fr-sheet">
        <h3>MIS CANJES</h3>
        <div class="fr-sub">Tus recompensas canjeadas y el estado de envío.</div>
        <div id="fr-hist-list"></div>
        <div class="fr-sheet-actions">
          <button class="fr-btn-ghost" id="fr-hist-close">Cerrar</button>
        </div>
      </div>`;
    document.body.appendChild(hist);
    hist.querySelector('#fr-hist-close').addEventListener('click', closeHistory);
    hist.addEventListener('click', e => { if (e.target === hist) closeHistory(); });
  }

  function openAddressForm(r) {
    ensureRedeemUI();
    addrReward = r;
    const prev = myRedemptions.find(x => x.ship_address);
    document.getElementById('fr-addr-name').value    = prev?.ship_name    || '';
    document.getElementById('fr-addr-phone').value   = prev?.ship_phone   || '';
    document.getElementById('fr-addr-address').value = prev?.ship_address || '';
    document.getElementById('fr-addr-city').value    = prev?.ship_city    || '';
    document.getElementById('fr-addr-title').textContent = 'ENVIAR: ' + r.name.toUpperCase();
    document.getElementById('fr-addr-err').classList.add('hidden');
    document.getElementById('fr-addr-overlay').classList.add('show');
  }

  function closeAddressForm() {
    const el = document.getElementById('fr-addr-overlay');
    if (el) el.classList.remove('show');
    addrReward = null;
  }

  async function submitAddressForm() {
    if (!addrReward) return;
    const ship = {
      name:    document.getElementById('fr-addr-name').value.trim(),
      phone:   document.getElementById('fr-addr-phone').value.trim(),
      address: document.getElementById('fr-addr-address').value.trim(),
      city:    document.getElementById('fr-addr-city').value.trim(),
    };
    const err = document.getElementById('fr-addr-err');
    if (!ship.name || !ship.phone || !ship.address) {
      err.textContent = 'Por favor completa nombre, teléfono y dirección.';
      err.classList.remove('hidden');
      return;
    }
    const r = addrReward;
    closeAddressForm();
    await finalizeRedemption(r, ship);
  }

  // ── MODAL ──
  function openModal(id) {
    const r = (SETTINGS.rewards || []).find(x => x.id === id);
    if (!r) return;
    pendingReward = r;
    document.getElementById('fr-modal-emoji').textContent = r.emoji;
    document.getElementById('fr-modal-title').textContent = 'CANJEAR: ' + r.name.toUpperCase();
    const shipNote = needsShipping(r.type) ? ' A continuación ingresarás tus datos de envío.' : '';
    document.getElementById('fr-modal-body').textContent  =
      `Usa ${r.pts.toLocaleString()} puntos para: ${r.desc} Actualmente tienes ${(customer.pts || 0).toLocaleString()} puntos.${shipNote}`;
    document.getElementById('fr-modal-confirm').onclick = confirmRedeem;
    document.getElementById('fr-modal').classList.remove('hidden');
  }

  function confirmRedeem() {
    if (!pendingReward) return;
    const r = pendingReward;
    if ((customer.pts || 0) < r.pts) { showToast('¡No tienes suficientes puntos!'); closeModal(); return; }
    closeModal();
    if (needsShipping(r.type)) {
      openAddressForm(r);
    } else {
      finalizeRedemption(r, null);
    }
  }

  async function finalizeRedemption(r, ship) {
    if ((customer.pts || 0) < r.pts) { showToast('¡No tienes suficientes puntos!'); return; }
    try {
      // 1) Record the redemption first — if this fails, we don't deduct points.
      const row = {
        customer_identifier: identifier,
        email:        customer.email || email || identifier,
        reward_id:    r.id,
        reward_name:  r.name,
        reward_type:  r.type,
        pts_spent:    r.pts,
        status:       ship ? 'pending' : 'processing',
        ship_name:    ship?.name    || null,
        ship_phone:   ship?.phone   || null,
        ship_address: ship?.address || null,
        ship_city:    ship?.city    || null,
      };
      const created = await db.createRedemption(row);
      if (!created) { showToast('No se pudo registrar el canje. Inténtalo de nuevo.'); return; }
      myRedemptions.unshift(created);

      // 2) Deduct points and log activity.
      const newPts      = (customer.pts || 0) - r.pts;
      const newRedeemed = (customer.redeemed || 0) + 1;
      const newActivity = [
        ...(customer.activity || []),
        { desc: `Canjeado: ${r.name}`, pts: -r.pts, date: new Date().toISOString() }
      ].slice(-50);
      customer = await db.updateCustomer(identifier, { pts: newPts, redeemed: newRedeemed, activity: newActivity });

      updateNavPts();
      renderStore();
      showToast('¡Canjeado: ' + r.name + '!');
    } catch(e) {
      showToast('El canje falló. Inténtalo de nuevo.');
      console.error(e);
    }
  }

  function closeModal() {
    document.getElementById('fr-modal').classList.add('hidden');
    pendingReward = null;
  }

  // ── HISTORY ──
  async function openHistory() {
    ensureRedeemUI();
    document.getElementById('fr-hist-overlay').classList.add('show');
    const listEl = document.getElementById('fr-hist-list');
    listEl.innerHTML = '<div class="fr-redo-empty">Cargando…</div>';
    try { myRedemptions = await db.getRedemptions(identifier) || []; } catch(e) {}
    renderHistory();
  }

  function closeHistory() {
    const el = document.getElementById('fr-hist-overlay');
    if (el) el.classList.remove('show');
  }

  function statusColor(s) {
    return {
      pending:    '#C9A84C',
      processing: '#5b9bd5',
      shipped:    '#5bd58a',
      delivered:  '#3ec76f',
      cancelled:  '#e06666',
    }[s] || '#888';
  }

  function renderHistory() {
    const listEl = document.getElementById('fr-hist-list');
    if (!myRedemptions || !myRedemptions.length) {
      listEl.innerHTML = '<div class="fr-redo-empty">Aún no tienes canjes.</div>';
      return;
    }
    const stages = ['pending','processing','shipped','delivered'];
    const stageLabels = { pending:'Pendiente', processing:'Procesando', shipped:'Enviado', delivered:'Entregado' };
    const statusLabels = { pending:'PENDIENTE', processing:'PROCESANDO', shipped:'ENVIADO', delivered:'ENTREGADO', cancelled:'CANCELADO' };
    listEl.innerHTML = myRedemptions.map(x => {
      const physical = !!x.ship_address;
      const st  = (x.status || 'pending').toLowerCase();
      const col = statusColor(st);
      let progress = '';
      if (physical && st !== 'cancelled') {
        const idx = stages.indexOf(st);
        progress = `<div class="fr-step">${stages.map((s,i)=>`
          <div class="s${i<=idx?' done':''}"><div class="dot"></div>${stageLabels[s]}</div>`).join('')}</div>`;
      }
      const track = x.tracking ? `<div class="fr-track">Guía de rastreo: ${x.tracking}</div>` : '';
      const date  = x.created_at ? new Date(x.created_at).toLocaleDateString('es-HN') : '';
      return `<div class="fr-redo">
        <div class="fr-redo-top">
          <div>
            <div class="fr-redo-name">${x.reward_name || 'Recompensa'}</div>
            <div class="fr-redo-meta">${TYPE_LABELS[x.reward_type] || x.reward_type || ''}${date ? ' • ' + date : ''}</div>
          </div>
          <div style="text-align:right">
            <span class="fr-badge" style="background:${col}22;color:${col}">${statusLabels[st] || st}</span>
            <div class="fr-redo-pts">−${(x.pts_spent || 0).toLocaleString()} pts</div>
          </div>
        </div>
        ${progress}
        ${track}
      </div>`;
    }).join('');
  }

  // ── HELPERS ──
  function showErr(id, msg) {
    const el = document.getElementById(id);
    el.textContent = msg;
    el.classList.remove('hidden');
  }
  function hideErr(id) { document.getElementById(id).classList.add('hidden'); }

  function showToast(msg) {
    const t = document.getElementById('fr-toast');
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(() => t.classList.remove('show'), 3000);
  }

  init();
  return { submitCode, filterBy, openModal, closeModal, confirmRedeem, zoomImage, closeImage, openHistory };
})();